export function showPaywall({ state }) {
	return state.ui.showPaywall;
}
export function expandedResponseID({ state }) {
	return state.ui.expandedResponseID;
}
export function isActiveEditKey({ state, key }) {
	return state.ui.editKeys[key];
}


// WEBPACK FOOTER //
// ./modules/lib/selectors/UISelectors.js